<template>
    <div style="display: flex;">
        <div @click="goInitialScreen" style="width: 50px; text-align: center; margin-top: 12px;">
            <img style="width: 32px;" :src="require('@/assets/img/common_x_btn.png')" alt="">
        </div>
        <div style="text-align: center; margin-top: 40%;">
            <div style=" margin-bottom: 40px;">
                <img style="width: 62px;" :src="require('@/assets/emblem.png')" alt="">
            </div>
            <div style="font-size: 20px;font-weight: 700;line-height: 28px;">계정이 삭제되었습니다</div>
            <div style="font-weight: 500;line-height: 24px; margin-top: 30px;">사커하우를 이용해주셔서 감사합니다.</div>
        </div>
        <div style="margin-top: 30%; text-align: center;">
            <div style="font-size: 12px;font-weight: 500;line-height: 20px;">계정은 바로 삭제되며, 일부 데이터가 남아있을 수 있습니다</div>
            <div @click="goInitialScreen" style="width: 310px; margin: 0 auto; margin-top: 40px; height: 63px; line-height: 63px; text-align: center; color: #fff; border-radius: 30px; background-color: #210F03; font-weight: 500;">초기화면으로 돌아가기</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CompleteWithdrawal',
    methods: {
        goInitialScreen() {
            location.href = '/'
        }
    }
}
</script>

<style scoped></style>